'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import { BRAND_CORE_MESSAGE } from '@/content/brand';

export default function Footer() {
  const [currentYear, setCurrentYear] = useState('2026');

  useEffect(() => {
    setCurrentYear(new Date().getFullYear().toString());
  }, []);

  const footerLinks = {
    product: [
      { label: 'How It Works', href: '/how-it-works' },
      { label: 'Pricing', href: '/pricing-plans' },
      { label: 'Get Started', href: '/get-started' },
    ],
    company: [
      { label: 'Home', href: '/homepage' },
      { label: 'Support', href: '/support-hub' },
      { label: 'Contact', href: '/support-hub' },
    ],
    legal: [
      { label: 'Privacy Policy', href: '#' },
      { label: 'Terms of Service', href: '#' },
      { label: 'Refund Policy', href: '#' },
    ],
  };

  return (
    <footer className="bg-primary text-white pt-16 pb-10">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          <div className="lg:col-span-2">
            <Link href="/homepage" className="flex items-center space-x-2.5 mb-6">
              <div className="flex items-center justify-center w-10 h-10 bg-accent rounded-lg shadow-sm">
                <Icon name="ShieldCheckIcon" size={20} className="text-accent-foreground" />
              </div>
              <span className="text-xl font-heading font-bold text-white">ParkPing</span>
            </Link>
            <p className="text-white/75 mb-6 max-w-md leading-relaxed">
              {BRAND_CORE_MESSAGE}. Built to make parking communication safer, clearer, and more private.
            </p>
            <div className="flex space-x-4">
              {['ShareIcon', 'ChatBubbleLeftIcon', 'CameraIcon', 'BriefcaseIcon'].map((icon, index) => (
                <button
                  key={index}
                  type="button"
                  className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-accent hover:text-accent-foreground transition-all duration-300"
                  aria-label="social"
                >
                  <Icon name={icon as any} size={20} />
                </button>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold text-white text-lg mb-4">Product</h3>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.label}>
                  <Link
                    href={link.href}
                    className="text-white/70 hover:text-white transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold text-white text-lg mb-4">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link
                    href={link.href}
                    className="text-white/70 hover:text-white transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold text-white text-lg mb-4">Legal</h3>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <Link
                    href={link.href}
                    className="text-white/70 hover:text-white transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-sm">
            <p className="text-white/70">
              {`(c) ${currentYear}`} ParkPing. All rights reserved. Built in India.
            </p>
            <div className="flex items-center space-x-8 text-white/70">
              <span>Trusted by urban drivers</span>
              <span>|</span>
              <span>Used across multiple cities</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}


